// Example starter JavaScript for disabling form submissions if there are invalid fields
const cookieBar = (function (window, jQuery) {
	"use strict";

	let $acceptBtn = jQuery('#cinfo-accept-button');
	let acceptBtnTextAll = $acceptBtn.data('accept-all');
	let acceptBtnTextSelected = $acceptBtn.data('accept-selected');

	// cinfo bar
	$acceptBtn.on('click', function (e) {
		var $thisBtn = jQuery(this);
		var reloadGTM = false;

		if ($thisBtn.hasClass('advanced')) {
			var selectedValue = 'B1-';
			var days = 1;

			var checkboxValue = 'A0-';

			if (jQuery('#checkBoxCInfoAnalitics').is(':checked')) {
				checkboxValue = 'A1-';
				days = 1095;
				reloadGTM = true;
			}

			selectedValue = selectedValue + checkboxValue;

			checkboxValue = 'M0';
			if (jQuery('#checkBoxCInfoMarketing').is(':checked')) {
				checkboxValue = 'M1';
			}

			selectedValue = selectedValue + checkboxValue;

			setCookie('AllowCookieLevel', selectedValue, days, '/');
		}
		else {
			setCookie('AllowCookieLevel', 'B1-A1-M1', 1095, '/');
			reloadGTM = true;
		}

		jQuery('#cookiesModal').modal('hide');

		if (reloadGTM) {
			reloadScript();
		}
	});

	function reloadScript() {
		var currentScript = jQuery('script[data-cinfostart="statistics"]');

		if (currentScript) {
			var freshScript = document.createElement('script');
			freshScript.textContent = currentScript.text();
			jQuery(currentScript).replaceWith(freshScript);
		}
	}

	function setCookie(name, value, days, path) {
		var expires = '';
		path = path || '/';

		if (days) {
			var date = new Date();
			date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
			expires = '; expires=' + date.toUTCString();
		}
		document.cookie = name + '=' + (value || '') + expires + '; path=' + path;
	}

	function getCookie(name) {
		var nameEQ = name + '=';
		var ca = document.cookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') c = c.substring(1, c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
		}
		return null;
	}

	function verifyCookieBar() {
		var cookieBarData = getCookie('AllowCookieLevel');

		if (cookieBarData != null && cookieBarData.indexOf("B1") >= 0) {
			if (cookieBarData.indexOf("A1") >= 0) {
				reloadScript();
			}
			return;
		}

		jQuery('#cookiesModal').modal('show');

		if ($acceptBtn.is(':hidden')) {
			jQuery('>Pravděpodobně používáte nástroj na blokování obsahu a reklamy. Webové stránky nemusí fungovat správně.</p>')
				.insertAfter('#cookiesModal');
		}
	}

	window.cookieBarButtonSetAdvanced = function () {
		$acceptBtn.text(acceptBtnTextSelected);
		$acceptBtn.addClass('advanced');
	};

	window.cookieBarButtonSetBasic = function () {
		$acceptBtn.text(acceptBtnTextAll);
		$acceptBtn.removeClass('advanced');
	};

	window.addEventListener(
		"load",
		function () {
			verifyCookieBar();
	});

})(window, jQuery);

export default cookieBar;
